"use strict";
exports.__esModule = true;
exports.generateCode = function (stringLength) {
    if (stringLength < 1 || stringLength > 255) {
        throw new Error('code-length invalid');
    }
    return (Math.random() * 10)
        .toString(36)
        .replace(/[^a-zA-Z0-9]+/g, '')
        .substr(0, stringLength);
};
//# sourceMappingURL=generate-code.js.map